import {
  Button,
  FormContextWrapper,
  Input,
  Layout,
  useFormValues,
} from '@pimbutton/tast-components-lib';
import registerUser from 'actions/authentication/register';
import { useReduxAction } from 'hooks/useReduxAction';
import React from 'react';
import { useHistory } from 'react-router';
import AuthVisual from '../AuthVisual/AuthVisual';

export default function Activate() {
  const { formValues, handleChange, errors, setErrors } = useFormValues({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    activation_code: '',
  });

  const dispatch = useReduxAction();
  const { push } = useHistory();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    dispatch(
      registerUser({
        ...formValues,
        useLicense: 1,
        organisation: 'Aventus opleiding Sociaal Werk',
      })
    ).catch(({ response }: { response: any }) => {
      const errs =
        response?.data?.message === 'invalid_license'
          ? { license_key: ['licentie code is niet geldig'] }
          : response?.data?.errors;

      setErrors((prev: any) => ({ ...prev, ...errs }));
    });
  }

  return (
    <Layout
      authVisual={<AuthVisual />}
      title="Account activeren"
      inputs={
        <FormContextWrapper
          onChange={handleChange}
          errors={errors}
          formValues={formValues}
        >
          <Input name="activation_code" label="Activatiecode" />
          <Input name="first_name" label="Voornaam" />
          <Input name="last_name" label="Achternaam" />
          <Input name="email" label="Email" />
          <Input name="password" label="Wachtwoord" />
          <Input name="password_confirmation" label="Bevestig wachtwoord" />
        </FormContextWrapper>
      }
      buttons={
        <>
          <Button fullWidth>Activeer account</Button>
          <Button fullWidth onClick={() => push('/inloggen')} variant="white">
            Al een Groow account?
          </Button>
        </>
      }
      handleSubmit={(e) => handleSubmit(e)}
    />
  );
}
